const prefix = 'fas';
const iconName = 'file';
const width = 384;
const height = 512;
const aliases = [128459, 61462, 128196];
const unicode = 'f15b';
const svgPathData = 'M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
